import { createSelector } from '@reduxjs/toolkit';
import type { State } from '../../types';
import type { PageGroup } from '../pageGroup';
import type { PageGroupItemViewModel, PageGroupViewModel } from '@trinnvis/dabih-api-client';

const selectPageGroups = (state: State): PageGroupViewModel[] => state.pageGroups;

export const getPageGroups = createSelector(selectPageGroups, (pageGroups): PageGroup[] =>
  pageGroups.map<PageGroup>((group) => {
    const pages: PageGroupItemViewModel[] = group.pages.map((page) => ({
      pageId: page.pageId,
      name: page.name,
      helpContent: page.helpContent,
    }));
    return {
      code: group.code,
      name: group.name,
      pages: pages,
    };
  }),
);
